import { Toaster } from "react-hot-toast";
import Routes from "./routes";
import "./App.scss";
import { useEffect, useState } from "react";
import { logoutAllTabs } from "./auth/login/Auth";
import { TimeDelay } from "./util/DateTimeUtils";

function App() {
  useEffect(() => {
    logoutAllTabs();
  }, []);

  const [refreshCount, setRefreshCount] = useState(0);

        useEffect(() => {
          console.log("Scheduler started for auto refresh.");
            const intervalId = setInterval(() => {
                window.location.reload();
                setRefreshCount(prevCount => prevCount + 1); 
                console.log("Scheduler ends for auto refresh.");
            }, TimeDelay(5, 0, 0)); 
            return () => clearInterval(intervalId);
        }, []);

  return (
    <div className="App">
      <Toaster />
      <Routes />
    </div>
  );
}

export default App;
